import { Box, Text } from '@mantine/core';
import type { FC } from 'react';
import { useHostContext } from '@/context/HostContext.tsx';
import { STEPPER_FULL_SIZE_AGENT_AVATAR_URL } from '@/stepper/constants.ts';
import { formatStepperDisplayPhoneNumber } from '@/stepper/utils.ts';
import { CLASS_NAMES } from '../../classNames';

interface StepperSetupCompleteProfileProps {
	agentName: string;
	agentPhoneNumber: string;
}

const StepperSetupCompleteProfile: FC<StepperSetupCompleteProfileProps> = ({
	agentName,
	agentPhoneNumber
}) => {
	const { localization } = useHostContext();
	const displayedAgentName =
		agentName.trim() ||
		localization.translate('creator', 'stepperOnboarding.profile.agentName');
	const displayedAgentPhoneNumber =
		formatStepperDisplayPhoneNumber(agentPhoneNumber);

	return (
		<Box
			className={CLASS_NAMES.setupCompleteProfile}
			data-testid="stepper-setup-complete-profile"
		>
			<Box className={CLASS_NAMES.setupCompleteProfileIdentity}>
				<Box className={CLASS_NAMES.setupCompleteAvatar}>
					<img
						alt=""
						className="h-full w-full object-cover object-center"
						src={STEPPER_FULL_SIZE_AGENT_AVATAR_URL}
					/>
				</Box>
				<Text className={CLASS_NAMES.setupCompleteAgentName}>
					{displayedAgentName}
				</Text>
			</Box>
			<Box className={CLASS_NAMES.setupCompletePhoneBlock}>
				<Text className={CLASS_NAMES.setupCompletePhoneLabel}>
					{localization.translate(
						'creator',
						'stepperOnboarding.profile.phoneTitle'
					)}
				</Text>
				<Text
					className={CLASS_NAMES.setupCompletePhoneNumber}
					data-testid="stepper-setup-complete-phone-number"
				>
					{displayedAgentPhoneNumber}
				</Text>
			</Box>
		</Box>
	);
};

export default StepperSetupCompleteProfile;
